<template>
    <div
        v-if="isVisible"
        :data-component="$options.name"
        class="z-overlay-ad border solid border-wildsand"
        :class="{
            'shadow-[0_7px_25px_0_rgba(0,0,0,.04),0_4px_12px_0_rgba(0,0,0,.04)] border-t-0':
                drawShadow && position.isTop,
            'shadow-[0_4px_12px_0_rgba(0,0,0,.04),0_7px_25px_0_rgba(0,0,0,.04)] border-b-0':
                drawShadow && position.isBottom,
            fixed: type.isFixed,
            sticky: type.isSticky,
            'top-0 rounded-b-10': position.isTop,
            'right-0': position.isRight,
            'bottom-0 rounded-t-10': position.isBottom,
            'left-0': position.isLeft,
        }"
    >
        <slot name="content" />
    </div>
</template>
<script lang="ts" src="./MsStickyContainer.ts" />
